import { render, staticRenderFns } from "./TbFilaAtendimentoOperador.vue?vue&type=template&id=636d26d9&scoped=true"
import script from "./TbFilaAtendimentoOperador.vue?vue&type=script&lang=js"
export * from "./TbFilaAtendimentoOperador.vue?vue&type=script&lang=js"
import style0 from "./TbFilaAtendimentoOperador.vue?vue&type=style&index=0&id=636d26d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636d26d9",
  null
  
)

export default component.exports